import { Component, OnInit, inject } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserService } from './auth/services/user.service';
import { SessionService } from './auth/services/session.service';
import { AuthService } from './auth/services/auth.service';
import { VersionCheckService } from './core/services/version-check.service';
import { CommonModule } from '@angular/common';
import { ScrollToTopComponent } from './shared/components/scroll-to-top/scroll-to-top.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToastModule,
    ConfirmDialogModule,
    CommonModule,
    ScrollToTopComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private readonly sessionService: SessionService,
    private readonly authService: AuthService,
    private readonly versionCheckService: VersionCheckService,
    private readonly router: Router,
  ) {
    authService.isAuthenticatedChange().subscribe();
  }

  ngOnInit(): void {
    this.sessionService.start();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const tree = this.router.parseUrl(this.router.url);
        const fragment = tree.fragment;
        if (fragment) {
          setTimeout(() => {
            const element = document.getElementById(fragment);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 150);
        } else {
          // Scroll para o topo
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
      });

    // inicia verificação automática de nova versão
    this.versionCheckService.start();
  }
}
